import { useWizard } from "react-use-wizard";
import sellSteps from "../../sellSteps";
import {
  TKeyOfDataWizardSell,
  TStringKeysOfIFillDataWizardSell,
} from "../../..";
import CommunicateStep from "../../../../../../../shared/wizard/steps/communicateStep";
import { EDealRequestCommunicationType } from "../../../../../../../shared/wizard/steps/types";

interface IDoNotKnowPriceSellStep_2 {
  onChange: (data: string, key: TStringKeysOfIFillDataWizardSell) => void;
  data: EDealRequestCommunicationType | null;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardSell[]) => void;
}

const DoNotKnowPriceSellStep_2 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: IDoNotKnowPriceSellStep_2) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(sellSteps.doNotKnowPrice.sell.step_1);
    onReset(["communicationType"]);
  };

  const handleNexStep = () => {
    goToStep(sellSteps.doNotKnowPrice.sell.step_3);
  };

  return (
    <div>
      <CommunicateStep
        handlePrevStep={handlePrevStep}
        handleNexStep={handleNexStep}
        onChange={onChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data}
      />
    </div>
  );
};

export default DoNotKnowPriceSellStep_2;
